import React, { useRef } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";

import LogoImg1 from "../../assets/images/logo/breitling.png";
import LogoImg2 from "../../assets/images/logo/frédérique_Constant_Logo.png";
import LogoImg3 from "../../assets/images/logo/hamilton.png";
import LogoImg4 from "../../assets/images/logo/junghans_logo.png";
import LogoImg5 from "../../assets/images/logo/maurice_Lacroix.png";
import LogoImg6 from "../../assets/images/logo/oris_logo.png";
import LogoImg7 from "../../assets/images/logo/tissot_Logo.png";
import LogoImg8 from "../../assets/images/logo/gigi.png";

const logoData = [
  { id: 1, img: LogoImg1 },
  { id: 2, img: LogoImg2 },
  { id: 3, img: LogoImg3 },
  { id: 4, img: LogoImg4 },
  { id: 5, img: LogoImg5 },
  { id: 6, img: LogoImg6 },
  { id: 7, img: LogoImg7 },
  { id: 8, img: LogoImg8 },
];

export const HomeLogoSlider = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1800,
    speed: 500,
    centerMode: true,
    slidesToShow: 5,
    centerPadding: "250px", // shows partial slides
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          centerPadding: "130px",
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          centerPadding: "150px",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          centerPadding: "120px",
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerPadding: "70px",
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="logo_slider">
      <Container fluid>
        <Row>
          <Col sm={12} className="text-center p-0">
            {/* <div className="position-relative">
              <Slider ref={sliderRef} {...settings} className="logo_sliderrr" >
                {logoData.map((item) => (
                  <div key={item.id} className="item text-center">
                    <Link to="/">
                      <img src={item.img} alt="Logo" className="img-fluid" />
                    </Link>
                  </div>
                ))}
              </Slider>

              
            </div> */}
            <div className="logo-marquee-wrapper position-relative">
  <div className="logo-marquee">
    {logoData.concat(logoData).map((item, index) => (
      <div key={index} className="logo-item">
        <Link to="/">
          <img
            src={item.img}
            alt="Logo"
            className="img-fluid"
          />
        </Link>
      </div>
    ))}
  </div>
</div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
